module.exports = __webpack_public_path__ + "img/work.d3df4901.svg";